import { IconArrowRight, IconSparkles } from '@tabler/icons-react'
import SpotlightCard from '../../components/SpotlightCard'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { item } from "../homepage/Section1"

const Section6 = () => {
    const SpotlightcardData = [
        {
            sno: "01",
            t1: "Automated Revenue Recovery",
            t2: "Scans every third-party order (DoorDash, Uber Eats, Grubhub) to detect missing or incorrect items and files evidence‑backed appeals automatically. Typical win rate: over 80%.",
            link: "/dispute-manager",
        },
        {
            sno: "02",
            t1: "Financial Reconciliation",
            t2: "Matches POS sales with delivery payouts and bank deposits, flags commission errors, tip discrepancies and missing adjustments, and syncs clean journal entries into accounting software.",
            link: "/finance",
        },
        {
            sno: "03",
            t1: "Operations Uptime & Quality Control",
            t2: "Monitors marketplace store status, auto-reopens offline locations, tracks order accuracy issues and alerts teams before revenue leaks occur.",
            link: "/downtime-controller"
        },
        {
            sno: "04",
            t1: "Reviews & Reputation Management",
            t2: "Centralizes ratings from delivery apps, Google and Yelp, then uses AI to draft timely, on-brand replies. Visual dashboards surface sentiment trends and top/bottom performers.",
            link: "/review-rating",
        },
        {
            sno: "05",
            t1: "Promotions & Ads Management",
            t2: "Tracks promos and ads across delivery platforms, showing ROI and acquisition. Voosh's experts manage campaigns end-to-end for brands that want hands-on guidance.",
            link: "/promotion-manager",
        },
    ]
  return (
    <div className='s6-partner f-width m-auto'>
        <p className="s4-h-text text-center">
        <IconSparkles className="color-brand animate__animated animate__bounceIn animate__infinite animate__slower" width="34" height="34" /> What We Deliver! </p>
        <motion.div variants={item} whileInView="visible" initial="hidden"  className='row'>
            {SpotlightcardData.map((item, index) => (
                <div key={index} className='col-sm-12 col-lg-4'>
                    <Link to={item.link}>
                        <SpotlightCard className="custom-spotlight-card2 shadow-sm" spotlightColor="#2C96FF60">
                            <p className='color-brand'>{item.sno}</p>
                            <motion.p variants={item} whileInView="visible" initial="hidden" className='s6-card-t1 text-dark'>{item.t1}</motion.p>
                            <motion.p variants={item} whileInView="visible" initial="hidden"  className='s6-card-t2 text-dark'>{item.t2}</motion.p>
                            <div className='d-flex justify-content-between'>
                                <motion.p variants={item} whileInView="visible" initial="hidden" className='s6-card-t2 fw-bold color-brand'>Learn more</motion.p>
                                <IconArrowRight className="color-brand" />
                            </div>
                        </SpotlightCard>
                    </Link>
                </div>
            ))}
            <div className='col-sm-12 col-lg-4'>
                <Link to={'/'}>
                    <SpotlightCard className="custom-spotlight-card2 shadow-sm align-content-end" spotlightColor="#2C96FF60">
                        <div className='d-flex justify-content-between'>
                            <motion.p variants={item} whileInView="visible" initial="hidden" className='s6-card-t2 fw-bold color-brand mb-0'>Explore all features</motion.p>
                            <IconArrowRight className="color-brand" />
                        </div>
                    </SpotlightCard>
                </Link>
                <div className="blur-color-1 rounded-pill"></div>
                <div className="blur-color-2 rounded-pill"></div>
            </div>
        </motion.div>
    </div>
  )
}

export default Section6